module.exports = __webpack_public_path__ + "img/download-icon.a095730d.svg";